import { Order, OrderLineItem } from "../../Interfaces/Orders";
import "./OrderContentsTable.css";
import {
  replaceCharacterWithSpace,
  convertToTitleCase,
} from "../../CommonFunctions";

type OrderContentsTableProps = {
  order: Order;
};

const OrderContentsTable = ({ order }: OrderContentsTableProps) => {
  const formatText = (text: string | null | undefined) => {
    if (!text) return "N/A";
    return convertToTitleCase(replaceCharacterWithSpace(text, "_"));
  };

  const getCustomizationEntry = (item: OrderLineItem) => {
    if (!item.customization) return <p className="customization-none">N/A</p>;
    const { bottle_text, clothing_size, design, font_style } =
      item.customization;

    return (
      <div className="customization-text customization-entry">
        <p>Bottle Text: {bottle_text || "N/A"}</p>
        <p>Clothing Size: {formatText(clothing_size)}</p>
        <p>Design Choice: {formatText(design?.split("_design")[0])}</p>
        <p>Font Style: {font_style || "N/A"}</p>
      </div>
    );
  };

  return (
    <div className="table-wrapper">
      <table className="order-table">
        <thead>
          <tr>
            <th>Image</th>
            <th>Product</th>
            <th>Quantity</th>
            <th>Customization</th>
          </tr>
        </thead>
        <tbody>
          {order.orderlineitem_set.map((item) => (
            <tr key={item.id}>
              <td data-label="Image">
                <img
                  src={item.product.image_url || ""}
                  alt={item.product.item_display_name}
                  className="product-image"
                />
              </td>
              <td data-label="Product" className="product-name">
                {item.product.item_display_name}
              </td>
              <td data-label="Quantity">
                <span className="quantity-badge">{item.quantity}</span>
              </td>
              <td data-label="Customization">{getCustomizationEntry(item)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrderContentsTable;
